import { get } from 'lodash-es';
import { getSuggestedDisplayPrice } from 'site-modules/shared/utils/core-page/suggested-price';
import { SITE_URL } from 'site-modules/shared/pages/seo';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';

function getTrimName({ trimName, trim }) {
  return trimName || trim;
}

function getTrimUrl({ trimName, submodels, makeModelSubmodelYear }) {
  if (!trimName) {
    return undefined;
  }

  const matchingSubmodels = submodels.filter(({ name }) => name === trimName);

  if (matchingSubmodels.length !== 1 || !matchingSubmodels[0].slug) {
    return undefined;
  }

  const { make, model, year } = makeModelSubmodelYear;

  return `${SITE_URL}${getCoreUrl({
    makeSlug: make.slug,
    modelSlug: model.slug,
    year,
    submodelSlug: matchingSubmodels[0].slug,
  })}`;
}

function getPrice(trimSummary) {
  const pricing = get(trimSummary, 'pricing', {});

  return getSuggestedDisplayPrice({
    nationalBasePriceTmv: get(pricing, 'nationalBasePrice.tmv'),
    suggestedPrice: pricing.suggestedPrice,
    totalMsrp: pricing.totalMsrp,
    baseMsrp: pricing.baseMsrp,
  });
}

export function getNewCoreTrimSchemas({ trimSummaries = [], submodels = [], makeModelSubmodelYear, pageUrl }) {
  if (!trimSummaries.length || !makeModelSubmodelYear) {
    return { offers: [], itemList: null };
  }

  const { make, model, year } = makeModelSubmodelYear;

  const entries = trimSummaries.map(trimSummary => {
    const trimName = getTrimName(trimSummary);
    const name = `${year} ${make.name} ${model.name} ${trimName}`;
    const price = getPrice(trimSummary);
    const url = getTrimUrl({ trimName, submodels, makeModelSubmodelYear });
    return {
      name,
      ...(price !== undefined && price !== null ? { price } : {}),
      priceCurrency: 'USD',
      sku: trimName,
      ...(url ? { url } : {}),
    };
  });

  return {
    offers: entries.map(entry => ({ '@type': 'Offer', ...entry })),
    itemList: {
      '@type': 'ItemList',
      url: pageUrl,
      itemListElement: entries.map((entry, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: entry.name,
        ...(entry.url ? { url: entry.url } : {}),
      })),
    },
  };
}
